export default __webpack_public_path__ + "static/media/srinagar4.e1cc404d.jpg";